var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAppsPanelMenu
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.away,
                  expression: "away"
                }
              ],
              staticClass: "apps-panel-menu"
            },
            [
              _c(
                "v-list",
                [
                  _vm._l(_vm.appsInfo, function(app, index) {
                    return [
                      _c(
                        "div",
                        {
                          key: app.id,
                          staticClass: "tile",
                          on: {
                            click: function($event) {
                              return _vm.switchApp(app, app.app_id, index)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(_vm._s(app.app_name))
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            { staticClass: "app-type" },
                            [
                              _c("v-list-tile-title", [
                                _vm._v(_vm._s(app.app_type))
                              ]),
                              _vm._v(" "),
                              _c("v-icon", [_vm._v("open_in_new")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          index + 1 < _vm.appsInfo.length
                            ? _c("v-divider")
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTnCView
        ? _c("app-terms", {
            attrs: { app: _vm.appNameForTnc, session: _vm.session }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }